import api from './api';

class PaymentService {
  connectStripeAccount(dataForm, merchant_code) {
    return api.post('/payment/connect-stripe-account', dataForm, {
        headers: {
        'MerchantCode': merchant_code
        }
      }
    );
  }

  disconnectStripeAccount(dataForm) {
    return api.post('/payment/disconnect-stripe-account', dataForm);
  }

  getLinkPayout (connect_account_id, merchant_code) {
    return api.get('/payment/get-link-payout?connect_account_id='+connect_account_id, {
        headers: {
        'MerchantCode': merchant_code
        }
      }
    );
  }

  getLinkConnect(dataForm) {
    return api.post('/payment/get-link-connect', dataForm);
  }

  connectExistingAccount(dataForm) {
    return api.post('/payment/connect-existing-account', dataForm);
  }

  connectAllinpay(dataForm) {
    return api.post('/payment/connect-allinpay', dataForm);
  }

  connectShopback(dataForm) {
    return api.post('/payment/connect-shopback', dataForm);
  }

  connectQlub(dataForm) {
    return api.post('/payment/connect-qlub', dataForm);
  }

  getStripeConnectInfoByMerchant(dataForm) {
    return api.post('/merchant/get-stripe-connect-info-by-merchant', dataForm);
  }

  saveDefaultPaymentMode(dataForm) {
    return api.post('/merchant/save-default-payment-mode', dataForm);
  }

  // Airwallex
  airwallexGetOnboardingLink(dataForm) {
    return api.post('/airwallex/get-onboarding-link', dataForm);
  }

  airwallexResumeOnboarding(dataForm) {
    return api.post('/airwallex/resume-onboarding', dataForm);
  }

  airwallexOnboardingStatus(dataForm) {
    return api.post('/airwallex/onboarding-status', dataForm);
  }

  airwallexRespondRfi(dataForm) {
    return api.post('/airwallex/respond-rfi', dataForm);
  }

  airwallexRefund(dataForm, merchant_code) {
    return api.post('/airwallex/refund', dataForm, {
      headers: {
        'MerchantCode': merchant_code,
      },
    });
  }

  // Kiosk order paid by card on the kiosk's Allinpay terminal: the BE voids it
  // (whole amount, same day, before the terminal is settled; past that, OATS).
  allinpayRefund(dataForm, merchant_code) {
    return api.post('/allinpay/refund', dataForm, {
      headers: {
        'MerchantCode': merchant_code,
      },
    });
  }

  airwallexListTransfers(params = {}) {
    return api.get('/airwallex/transfers', { params });
  }

  // Airwallex wallet ledger (balance pages)
  airwallexBalanceSummary(params = {}) {
    return api.get('/airwallex/balance-summary', { params });
  }

  airwallexBalanceTransactions(params = {}) {
    return api.get('/airwallex/balance-transactions', { params });
  }

  airwallexBalanceTransaction(id) {
    return api.get('/airwallex/balance-transactions/' + id);
  }

  airwallexExportBalanceTransactions(params = {}) {
    return api.get('/airwallex/balance-transactions/export', { params, responseType: 'blob' });
  }

  airwallexUncreditedPayments(params = {}) {
    return api.get('/airwallex/uncredited-payments', { params });
  }

  // Copies the wallet from Airwallex now instead of waiting for the 30-minute sync.
  airwallexBalanceRefresh(data = {}) {
    return api.post('/airwallex/balance-refresh', data);
  }
}

export default new PaymentService();
